import { render, staticRenderFns } from "./RenewContracts.vue?vue&type=template&id=2c53090c&scoped=true"
import script from "./RenewContracts.vue?vue&type=script&lang=js"
export * from "./RenewContracts.vue?vue&type=script&lang=js"
import style0 from "./RenewContracts.vue?vue&type=style&index=0&id=2c53090c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53090c",
  null
  
)

export default component.exports